<template>
  <v-dialog v-model="dialog">
    <v-card>
      <v-card-title class="headline">Confirm your phone</v-card-title>
      <v-card-text>
        A confirmation code has been sent to the number you provided. Enter it below
        <v-text-field
          label="Confirmation code"
          v-model="code"
          class="mt-3"
          autofocus
          required
        />
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn flat @click="cancel">Cancel</v-btn>
        <v-btn flat color="primary" @click="handleSubmit(code)" :loading="loading">Confirm</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: {
    buy: Object,
    dialog: Boolean
  },
  data () {
    return {
      code: '',
      loading: false,
      snackbar: false,
      snackbarMessage: ''
    }
  },
  methods: {
    ...mapActions(['confirmCode']),
    handleSubmit (code) {
      this.loading = true
      const params = {
        phoneNumber: this.buy.customer.phone_number,
        code: code
      }
      this.confirmCode(params)
        .then((response) => {
          this.$emit('confirm')
        })
        .catch((error) => {
          console.log(error)
          if (error.response.data) {
            const msg = error.response.data.message
            this.$emit('show-error', msg)
          }
        })
        .then(() => {
          this.loading = false
        })
    },
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/CheckInConfirmationCode.vue